import React, { useRef, useState } from "react";
import { ArrowLeft, Upload, Send } from "lucide-react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import LinkExtension from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";
import RichToolbar from "./RichToolbar";
import { topicTypeLabel } from "./constants";

const CreateForm: React.FC<{ onBack: () => void; onSubmit: (d: any) => void }> = ({ onBack, onSubmit }) => {
  const [type, setType] = useState("STANDARD");
  const [title, setTitle] = useState("");
  const [files] = useState<File[]>([]);
   const fileRef = useRef<HTMLInputElement>(null);

  const editor = useEditor({
    extensions: [
      StarterKit,
      LinkExtension.configure({ openOnClick: false }),
      Placeholder.configure({ placeholder: "Partagez des nouvelles avec vos clients..." }),
    ],
    editorProps: {
      attributes: {
        class: "outline-none min-h-[150px] text-sm p-4 leading-relaxed",
      },
    },
  });

  const handleFiles = (f: FileList | null) => {
    if (!f) return;
    };

  return (
     <div className="flex flex-col h-full bg-white">
      <div className="px-6 py-4 border-b flex items-center gap-3">
        <button onClick={onBack} className="p-2 hover:bg-slate-100 rounded-xl transition-colors"><ArrowLeft size={18} /></button>
        <span className="font-bold text-slate-800">Créer une publication</span>
      </div>
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        <div className="grid grid-cols-4 gap-2">
          {Object.entries(topicTypeLabel).map(([key, val]) => (
            <button key={key} onClick={() => setType(key)} className={`py-3 rounded-xl border-2 text-[10px] font-black uppercase transition-all ${type === key ? "border-blue-600 bg-blue-50 text-blue-700" : "border-slate-100 text-slate-400 hover:border-slate-200"}`}>{val.label}</button>
          ))}
        </div>
        {(type === "EVENT" || type === "OFFER") && (
          <input value={title} onChange={e => setTitle(e.target.value)} placeholder="Titre de l'événement..." className="w-full p-4 rounded-xl border border-slate-200 focus:ring-2 focus:ring-blue-100 outline-none" />
        )}
        <div className="border border-slate-200 rounded-2xl overflow-hidden shadow-sm">
          <RichToolbar editor={editor} />
          <EditorContent editor={editor} />
        </div>
        <div onClick={() => fileRef.current?.click()} className="h-32 border-2 border-dashed border-slate-200 rounded-2xl flex flex-col items-center justify-center gap-2 cursor-pointer hover:bg-blue-50/50 hover:border-blue-300 transition-all">
          <div className="p-3 bg-slate-50 rounded-full text-slate-400"><Upload size={20} /></div>
          <span className="text-xs font-bold text-slate-500">Ajouter des photos/vidéos ({files.length})</span>
          <input ref={fileRef} type="file" multiple className="hidden" onChange={e => handleFiles(e.target.files)} />
        </div>
      </div>
      <div className="p-6 border-t"><button onClick={() => onSubmit({ type, title, content: editor?.getHTML(), files })} className="w-full py-4 bg-blue-600 text-white rounded-2xl font-black uppercase tracking-widest hover:bg-blue-700 shadow-lg shadow-blue-100 transition-all flex items-center justify-center gap-2"><Send size={16} /> Publier maintenant</button></div>
    </div>
  );
};

export default CreateForm;